// src/utils/endpoints.js
export const AUTH_ENDPOINTS = {
  auth: '/api/auth/auth', // POST - Universal authentication (sign-in/sign-up)
  login: '/api/auth/login', // POST - Legacy sign-in endpoint
  signup: '/api/auth/signup', // POST - Legacy sign-up endpoint
  magicLink: '/api/auth/magic-link', // GET - Dynamic endpoint: /api/auth/magic-link/{token}
  me: '/api/auth/me', // GET - Get current user info
  
  createUser: '/api/auth/admin/users', // POST - Admin: Create new user
  
  testMagicLinkInfo: '/api/auth/test/magic-link-info', // GET - Test endpoint (base path)
};

// Dubbing API endpoints
export const DUBBING_ENDPOINTS = {
  // Videos
  uploadVideo: '/api/dubbing/videos/upload', // POST - Upload video file
  listVideos: '/api/dubbing/videos', // GET - List user's videos
  deleteVideo: '/api/dubbing/videos', // DELETE - /api/dubbing/videos/{video_id}
  
  // Dubbing Jobs
  createDubbingJob: '/api/dubbing/videos', // POST - /api/dubbing/videos/{video_id}/dub
  getJobStatus: '/api/dubbing/jobs', // GET - /api/dubbing/jobs/{job_id}/status
  listJobs: '/api/dubbing/jobs', // GET - List dubbing jobs
  cancelJob: '/api/dubbing/jobs/{{ID}}/cancel', // POST - /api/dubbing/jobs/{job_id}/cancel
  deleteJob: '/api/dubbing/jobs', // DELETE - /api/dubbing/jobs/{job_id}
  
  // Info
  getLanguages: '/api/dubbing/languages', // GET - Get supported languages
  getUserStats: '/api/dubbing/stats', // GET - Get user statistics
  getSystemStatus: '/api/dubbing/system/status', // GET - Get system status

  submitContactForm: '/api/contact/' // POST - Submit contact form
};

// Route constants for frontend routing
export const FRONTEND_ROUTES = {
  HOME: '/',
  SIGN_IN: '/signin',
  DUBBING: '/dubbing',
  AUTH_CODE: '/auth/code',
  MAGIC_LINK: '/auth/magic-link', // For handling magic link tokens
};

// API Response types for TypeScript-like documentation
export const API_RESPONSE_TYPES = {
  // Universal Auth Response
  UNIVERSAL_AUTH: {
    message: 'string',
    requires_otp: 'boolean', // Always false for magic link
    is_new_user: 'boolean' // Indicates if this was a sign-up
  },
  LOGIN: {
    message: 'string',
    requires_otp: 'boolean' // Always false for magic link
  },
  TOKEN: {
    access_token: 'string',
    token_type: 'string', // "bearer"
    user: {
      email: 'string',
      role: 'string' // "user" | "admin"
    }
  },
  USER_INFO: {
    email: 'string',
    role: 'string',
    status: 'string',
    usage_count: 'number',
    usage_limit: 'number | null',
    total_charges: 'number',
    created_at: 'string',
    last_login: 'string | null'
  },
  ERROR: {
    detail: 'string',
    code: 'string?',
    field: 'string?'
  }
};

// HTTP Status codes for reference
export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  CONFLICT: 409,
  RATE_LIMITED: 429,
  INTERNAL_SERVER_ERROR: 500,
};

// Request timeout configurations
export const REQUEST_CONFIG = {
  DEFAULT_TIMEOUT: 30000, // 30 seconds
  UPLOAD_TIMEOUT: 300000, // 5 minutes for file uploads
};